import React, { useState, useEffect, lazy, Suspense } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import * as urls from "../../utils/URLConst";
import toastNotify from "../../utils/ToastNotify";
import { computeCrc } from "../../utils/CRC32";
import { encData, setUserData } from "../../utils/Common";
import { setLocalAccessToken, setLocalRefreshToken, AuthKey } from "../../utils/Common";
import OtpField from "../../componants/textField/OtpField";
import { Link } from "react-router-dom";
import { BiLoader, BiRefresh } from "react-icons/bi";
import Loader from "../../componants/loader/Loader";
const LoginLayout = lazy(() => import('./LoginLayout'));

const OtpSample = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [IsLoading, setIsLoading] = useState(false);
  const [isSmsResend, setIsSmsResend] = useState(false);
  const [smsTimer, setSmsTimer] = useState(120);
  const identifyData = JSON.parse(localStorage.getItem("_identityData"));

  const joinOTP = otpValues.join();
  const OTPValues = joinOTP.replace(/,/g, "");

  useEffect(() => {
    var reloadflag = sessionStorage.getItem("reloadflag");
    if (reloadflag === "1" || state === null) {
      navigate("/");
    } else {
      sessionStorage.setItem("reloadflag", "1");
    }
  }, [state])

  useEffect(() => {
    const timer = setInterval(() => {
      setSmsTimer((prevTime) => prevTime - 1);
      if (smsTimer === 0) {
        setSmsTimer(0);
        setIsSmsResend(true);
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [smsTimer]);

  async function handleOtpReset() {
    try {
      setIsLoading(true);
      const payload = {
        OTP_TOKEN: state.OTP_TOKEN,
        // SESSION_ID: state.OTP_TOKEN,
        MOBILE_NO: state?.MOBILE_NO ? encData(state?.MOBILE_NO) : "",
        EMAIL: state?.EMAIL ? encData(state?.EMAIL) : "",
        DOMAIN_NM: window.location.hostname,
        IP_ADDRESS: identifyData?.ip || ""
      };
      const checksum = computeCrc(JSON.stringify(payload));
      await axios({
        method: "POST",
        url: urls.OtpResend,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Checksum: checksum,
          Authorization: AuthKey,
        },
      }).then((result) => {
        if (result.data.STATUS === "0") {
          toastNotify(result.data.MESSAGE, "success");
          setSmsTimer(120);
          setIsSmsResend(false);
          setOtpValues(["", "", "", "", "", ""]);
        } else if (result.data.STATUS === "3") {
          navigate("/");
          toastNotify(result.data.MESSAGE, "error");
        } else {
          toastNotify(result.data.MESSAGE, "error");
          setOtpValues(["", "", "", "", "", ""]);
        }
      });
    } catch (error) {
      // Ignore
    } finally {
      setIsLoading(false);
    }
  }

  async function handleOtpVerify() {
    try {
      setIsLoading(true);
      const payload = {
        OTP_TOKEN: state?.OTP_TOKEN ? state?.OTP_TOKEN : "",
        MOBILE_NO: state?.MOBILE_NO ? encData(state?.MOBILE_NO) : "",
        EMAIL: state?.EMAIL ? encData(state?.EMAIL) : "",
        OTP_CD: encData(OTPValues),
        DOMAIN_NM: window.location.hostname,
        IP_ADDRESS: identifyData?.ip || ""
      };
      const checksum = computeCrc(JSON.stringify(payload));

      await axios({
        method: "POST",
        url: urls.OtpVerify,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Checksum: checksum,
          Authorization: AuthKey,
        },

      }).then((result) => {
        if (result.data.STATUS === "0") {
          const response = result.data.RESPONSE[0];
          setUserData(response);
          setLocalAccessToken(response.ACCESS_TOKEN);
          setLocalRefreshToken(response.REFRESH_TOKEN);
          navigate("/dashboard");
        } else if (result.data.STATUS === "3") {
          navigate("/");
          toastNotify(result.data.MESSAGE, "error");
        } else {
          toastNotify(result.data.MESSAGE, "error");
          setOtpValues(["", "", "", "", "", ""]);
        }
      });
    } catch (error) {
      // Ignore Case;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const validateOTP = () => {
      if (OTPValues.length < 6) {
        return false;
      } else {
        handleOtpVerify();
      }
    };
    validateOTP();
  }, [OTPValues.length]);


  return (
    <>
      <Suspense fallback={<Loader />}>
        <LoginLayout title="OTP Verification">
          <div className="form-group mt-2">

            {state?.authType === "S" &&
              <p className="text-center mt-2 text-sm">OTP has been send on your registered mobile no. ******{state.MOBILE_NO.substr(state.MOBILE_NO.length - 4)}</p>
            }
            {state?.authType === "M" &&
              <div className="text-xs text-slate-500 text-center mt-2">OTP has been send on your registered Email id **{state.EMAIL.split("@")[0].substr(state.EMAIL.split("@")[0].length - 4)}@{state.EMAIL.split("@")[1]}</div>
            }
            <div className="mt-3">
              <OtpField
                name="OTP"
                otpValues={otpValues}
                setOtpValues={setOtpValues}
                style={{ height: "40px", width: "40px" }}
              />
            </div>

            <div className="text-center mt-2">
              {!IsLoading ? '' : <><BiLoader className='bx-spin text-lg' /> Loading...</>}
            </div>

            <div className="otptimer text-center mt-3">
              {isSmsResend ? (
                <span className="outstanding-amount-text text-primary" onClick={handleOtpReset}>
                  <BiRefresh className='text-sm text-lg me-1' />
                  OTP Resend
                </span>
              ) : (
                <span className="">{smsTimer} Seconds</span>
              )}
            </div>
          </div>

          <div className="text-center text-sm mt-3">
            <Link to="/" className='ms-1' >
              Click here back to go login
            </Link>
          </div>
        </LoginLayout>
      </Suspense >
    </>
  );
};

export default OtpSample;
